var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row h-100 justify-content-center align-items-center b-load"},[_c('div',{staticClass:"col-12"},[_c('i',{staticClass:"fa-solid fa-circle-notch fa-spin fa-5x text-danger"}),_c('h3',{staticClass:"mt-4 text-danger"},[_vm._v("Cargando")])])])
}]

export { render, staticRenderFns }